import React from "react";
import { Route, Routes } from "react-router-dom";
import FlespiMainPage from "../pages/FlespiMainPage";
import FlespiDevicesPage from "../pages/FlespiDevicesPage";

export default function FlespiRoutes() {
  return (
    <Routes>
      <Route index element={<FlespiMainPage />} />
      <Route path="dispositivos/:slug" element={<FlespiDevicesPage />} />
      <Route path="dispositivos" element={<FlespiDevicesPage />} />
      <Route path="*" element={<FlespiMainPage />} />
    </Routes>
  );
}
